var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 113 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6661_74860)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.9932,
    cy: 48,
    r: 48,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9932,
    cy: 48,
    r: 32,
    fill: "url(#paint0_linear_6661_74860)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6915 54.0317C57.6126 54.1189 57.5391 54.2107 57.4715 54.3067C57.4021 54.4089 57.3466 54.5199 57.3065 54.6367C57.2536 54.7407 57.2165 54.8519 57.1965 54.9667C57.1875 55.0888 57.1875 55.2114 57.1965 55.3334C57.1903 55.5739 57.2405 55.8125 57.3431 56.0301C57.5098 56.4907 57.8725 56.8534 58.3331 57.0201C58.7769 57.2162 59.2827 57.2162 59.7265 57.0201C60.187 56.8534 60.5498 56.4907 60.7165 56.0301C60.7979 55.8072 60.8352 55.5706 60.8265 55.3334C60.8293 54.8461 60.638 54.3777 60.2948 54.0317C59.9506 53.6847 59.482 53.4895 58.9931 53.4895C58.5043 53.4895 58.0357 53.6847 57.6915 54.0317ZM58.9931 29.6667C48.8679 29.6667 40.6598 37.8749 40.6598 48.0001C40.6598 58.1253 48.8679 66.3334 58.9931 66.3334C69.1183 66.3334 77.3265 58.1253 77.3265 48.0001C77.3265 43.1378 75.3949 38.4746 71.9567 35.0365C68.5186 31.5983 63.8554 29.6667 58.9931 29.6667ZM58.9931 62.6667C50.8929 62.6667 44.3265 56.1003 44.3265 48.0001C44.3265 39.8999 50.8929 33.3334 58.9931 33.3334C67.0933 33.3334 73.6598 39.8999 73.6598 48.0001C73.6598 51.8899 72.1146 55.6204 69.364 58.371C66.6135 61.1215 62.883 62.6667 58.9931 62.6667ZM58.9931 38.8334C57.0269 38.8322 55.2096 39.8806 54.2265 41.5834C53.8652 42.1517 53.8446 42.8724 54.1727 43.4604C54.5009 44.0484 55.1251 44.4092 55.7984 44.4001C56.4718 44.391 57.086 44.0135 57.3981 43.4167C57.7269 42.8473 58.3355 42.4975 58.9931 42.5001C60.0056 42.5001 60.8265 43.3209 60.8265 44.3334C60.8265 45.3459 60.0056 46.1667 58.9931 46.1667C57.9806 46.1667 57.1598 46.9876 57.1598 48.0001V49.8334C57.1598 50.8459 57.9806 51.6667 58.9931 51.6667C60.0056 51.6667 60.8265 50.8459 60.8265 49.8334V49.5034C63.3289 48.5954 64.8218 46.0255 64.371 43.4019C63.9202 40.7782 61.6551 38.8541 58.9931 38.8334V38.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6661_74860",
    x: 0.993164,
    y: -6,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6661_74860"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_6661_74860"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6661_74860",
    result: "effect2_dropShadow_6661_74860"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6661_74860",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6661_74860",
    x1: 39.6801,
    y1: 91.5134,
    x2: 106.474,
    y2: 91.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE5C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.6a523954698bfe7c328f4f8f4532a475.svg";
export { ForwardRef as ReactComponent };